import { Injectable, WritableSignal, signal } from '@angular/core';
import { NotificationModel, NotificationType } from './notification.model';

@Injectable({
    providedIn:'root'
})
export class NotificationService {

    public _notifications: WritableSignal<NotificationModel|any> = signal(null);
    private _idx = 0;
  
  
    getNotifications() {
      return this._notifications;
    }

    private sendNotification(type: NotificationType, title: string, timeout: number, message?: string) {
      const notification = new NotificationModel(this._idx++, type, title, timeout, message);
      this._notifications.set(notification);
    }
  
    info(title: string, message?: string, timeout = 3000) {
      this.sendNotification(NotificationType.Info, title, timeout, message);
    }
  
    success(title: string, message?: string, timeout = 3000) {
      this.sendNotification(NotificationType.Success, title, timeout, message);
    }
  
    warning(title: string, message?: string, timeout = 3000) {
      this.sendNotification(NotificationType.Warning, title, timeout, message);
    }
  
    error(title: string, message?: string, timeout = 5000) {
      this.sendNotification(NotificationType.Error, title, timeout, message);
    }

  }
